import toast from 'react-hot-toast';
import { logout } from '../store/authSlice';
import { store, persistor } from '../store/store';

// Clears auth state and redirects to sign-in when a session expires.
export function handleSessionExpired() {
  persistor.purge();
  store.dispatch(logout());
  toast.error('Your session has expired. Please sign in again.', { duration: 3000 });
  setTimeout(() => window.location.replace('/auth/signin'), 1500);
}
